
export const certificates =[
    {
        id:1,
        certificateIssuer:'Coursera.org',
        certificateLink:'pdf/coursera.pdf',
        certificateImage:'pdf/Certificate1.jpg'
    },
    {
        id:2,
        certificateIssuer:'Udemy.com',
        certificateLink:'pdf/udemy.pdf',
        certificateImage:'pdf/Certificate4.jpg'
    },
    {
        id:3,
        certificateIssuer:'integrify software academy',
        certificateLink:'pdf/integrify.pdf',
        certificateImage:'pdf/Certificate2.jpg'
    },
    {
      id:4,
      certificateIssuer:'Blue Road Academy',
      certificateLink:'pdf/salesforceAssociate.pdf',
      certificateImage:'pdf/Certificate3.jpg'
  },
]

export  const projects =[
    {
      projectId:1,
      projectName:"Country finder",
      projectDescription:`A list of country with information related population, 
      area, country code searching, adding to favorite, deleting from favorite`,
      projectLink:'https://country-detail-finder.netlify.app/',
      //projectImage:'images/country-finder.jpg'
    },
    {
      projectId:2,
      projectName:"Birhane.kahsay",
      projectDescription:`A private blog site that shows what Birhane do, what skills he has, 
      what certificates does he have and where and what he wants to work`,
      projectLink:`https://birhane-kahsay-own-website.vercel.app/`,
      //projectImage:'images/own-web.jpg'
    },
    {
      projectId:3,
      projectName:"Delivery Calculator",
      projectDescription:`A delivery calculator application that calculates the fee of delivery based on number of quantity, 
      delivery distance, delivery time and delivery total cost of the purchased one`,
      projectLink:'https://delivery-delivery-fee-2.vercel.app/',
      //projectImage:'images/calculator.jpg '
    },
    {
      projectId:4,
      projectName:"PDF splitter and online Note",
      projectDescription:`This is an online application for PDF splitting and to write notes and save them online`,
      projectLink:`https://birhane.pythonanywhere.com/`,
      //projectImage:'images/blog.jpg'
    },
    {
      projectId:5,
      projectName:"Online blog",
      projectDescription:`This is an online blog that you can post articles on different areas of science.`,
      projectLink:`https://birhanek.pythonanywhere.com/news/`,
    }
  ]